import deepmerge from 'deepmerge';

export function createSlice(initialState) {
    let state = structuredClone(initialState);

    function getState() {
        return structuredClone(state);
    }

    function setState(partial) {
        state = deepmerge(state, partial);
    }

    return {
        getState,
        setState,
    };
}
